import styled from "@emotion/styled";
import { themes } from "../../../../../styles/theme";

export const WrapModalContent = styled.div`
  max-width: 473px;
  width: 100%;
  background: ${themes.dark.surface.main.primary.default};
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  margin: auto;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  outline: 0;
`;
